<template>
  <el-container class="SaleForm">
    <el-main class="p-0">
      <el-form
        ref="form"
        label-width="70px"
        class="form-label-70"
        :model="data"
        :rules="rules"
        inline
      >
        <el-row>
          <el-col :span="6">
            <el-form-item label="거래처" prop="customer_name">
              <ACustomerSelector
                v-model="data.customer_name"
                :disabled="!!customer"
                seller
                @select="handleSelectCustomer"
              />
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="우편번호" prop="zipcode">
              <el-input
                v-model="data.zipcode"
                class="zipcode readonly"
                readonly
              />
              &nbsp;
              <el-button @click="popupZipcode(handleCompleteZipcode)"
                >우편번호검색</el-button
              >
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="도착지" prop="destination">
              <el-input ref="destination" v-model="data.destination" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">
            <el-form-item label="매출일" prop="sale_date">
              <ADatePicker v-model="data.sale_date" />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="납기일" prop="delivery_date">
              <ADatePicker v-model="data.delivery_date" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="출하" prop="delivery_way_flag">
              <ADeliveryWaySelector
                v-model="data.delivery_way_flag"
                @change="handleChangeDeliveryWay"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <ATradeTable
        ref="trade"
        :items="data.details"
        :customer="customer"
        showSaleOnly
        showField
        @changedSum="handleChangedSum"
      />
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['f4']"
        v-if="is_new"
        :loading="load_button"
        @shortkey.native="handleClickRegister"
        @click="handleClickRegister"
        >등록 (F4)</el-button
      >
      <el-button class="right" @click="closeDialog"
        >{{ $t("button.close") }} (Esc)</el-button
      >
    </el-footer>
  </el-container>
</template>
<script>
import { form } from "@/common/mixins/form";
import { sale_form } from "@/common/mixins/sale_form";
import { zipcode_search } from "@/common/mixins/zipcode_search";

export default {
  name: "SaleForm",
  mixins: [form, sale_form, zipcode_search],
  data() {
    return {
      title: "매출",
      sum: 0,
      rules: {
        customer_name: [{ required: true, message: "거래처를 선택해 주세요." }],
        sale_date: [{ required: true, message: "매출일을 선택해 주세요." }],
        delivery_date: [{ required: true, message: "납기일을 선택해 주세요." }],
        delivery_way_flag: [
          { required: true, message: "출하방법을 선택해 주세요." },
        ],
      },
      temp_customer: null,
      working: false,
      load_button: false,
    };
  },
  props: {
    data: {
      type: Object,
      default: function() {
        return {
          id: 0,
          code: "",
          customer_id: 0,
          customer_name: "",
          zipcode: "",
          destination: "",
          sale_date: this.util.getDate(0),
          delivery_date: this.util.getDate(1),
          delivery_way_flag: null,
          price: 0,
          details: [],
        };
      },
    },
    customer: {
      type: Object,
      default: null,
    },
  },
  computed: {
    is_new: function() {
      return this.data.id < 1;
    },
  },
  mounted() {
    if (!this.customer) {
      return;
    }
    let c = this.customer;
    this.temp_customer = c;
    this.data.customer_id = c.id;
    this.data.customer_name = c.name;
    this.data.destination = this.util.getCustomerAddress(c);
  },
  methods: {
    doRegister() {
      const trades = this.$refs.trade.result();
      const details = [];
      for (let i = 0; i < trades.length; i++) {
        if (!trades[i].product_name && !trades[i].amount) {
          continue;
        }
        let detail = Object.assign({}, trades[i]);
        detail.seq = i + 1;
        details.push(detail);
      }
      let data = Object.assign({}, this.data);
      data.price = this.sum;
      data.details = details;
      this.load_button = true;
      this.api.createSale(data).then((res) => {
        this.load_button = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.util.notify_success(this, this.title, "등록되었습니다.");
        this.$emit("completed", true);
      });
    },
    handleSelectCustomer(c) {
      if (typeof c === "string") {
        this.temp_customer = null;
        this.data.customer_id = null;
        this.data.customer_name = c;
        this.data.zipcode = "";
        this.data.destination = "";
      } else {
        this.temp_customer = c;
        this.data.customer_id = c.id;
        this.data.customer_name = c.name;
        this.data.zipcode = this.util.getCustomerZipcode(c);
        this.data.destination = this.util.getCustomerAddress(c);
      }
    },
    handleChangedSum(sum) {
      this.sum = sum;
    },
    handleClickRegister() {
      if (this.working) {
        return;
      }
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        let details = this.getDetails();
        if (details.length < 1) {
          this.util.notify_warning(this, this.title, "내역을 입력해 주세요.");
          return;
        }
        if (this.invalid_details.length > 0) {
          this.util.notify_warning(
            this,
            this.title,
            this.invalid_details +
              "번째 품명을 올바르게 선택하지 않으셨습니다. 다시 선택하여 주시기 바랍니다."
          );
          return;
        }
        // this.working = true;
        if (this.isNew && this.util.isPastDate(this.data.sale_date)) {
          this.util.confirm(
            this,
            this.title,
            "매출일이 오늘보다 늦습니다. 계속 등록하시겠습니까?",
            this.doRegister
          );
          return;
        }
        this.doRegister();
      });
    },
    handleCompleteZipcode(zipcode, addr) {
      this.data.zipcode = zipcode;
      this.data.destination = addr + " ";
      this.$refs.destination.focus();
    },
    handleChangeDeliveryWay() {
      let info = this.util.getAddressByDeliveryWay(
        this.data.delivery_way_flag,
        this.temp_customer
      );
      if (!info) {
        return;
      }
      this.data.zipcode = info.zipcode;
      this.data.destination = info.addr;
    },
  },
};
</script>
